import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import withResponsive from "../hoc/withResponsive";
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';

export function generateListCardLayout(reactChildren, theme) {
  const children = React.Children.toArray(reactChildren);

  return (
    children.map((item, index) => (
      <RowContainer key={index} small columns={['47.5rem']}>
        <ColumnContainer
          columns={[themeResponsiveProperty(ROW_HEIGHT_SMALL_REM_MOBILE, ROW_HEIGHT_SMALL_REM_TABLET)({ theme })]}
        >
          {item}
        </ColumnContainer>
      </RowContainer>
    ))
  )
}

export function generateGridCardLayout(reactChildren, theme) {
  const children = React.Children.toArray(reactChildren);

  const render = [];

  while (children.length > 0) {
    render.push(
      <RowContainer
        key={children.length}
        small
        columns={themeResponsiveProperty(['50%', '50%'], ['33.333333%', '33.333333%', '33.333333%'])({ theme })}
      >
        {children.splice(0, themeResponsiveProperty(2, 3)({ theme }))}
      </RowContainer>
    );

  }

  return render;
}

export const PseudoRandomCardLayout = withResponsive(function (props) {
  const reactChildren = React.Children.toArray(props.children);

  if (props.isMobile) {
    return mobileRows(reactChildren);
  } else if (props.isTablet) {
    return tabletRows(reactChildren);
  } else {
    return null;
  }
});

function tabletRows(children){
  const render = [];

  while (children.length > 0) {
    render.push(
      <RowContainer key={children.length} columns={['31.6666666667rem', '15.8333333333rem']}>
        {children.splice(0, 1)}

        {children.length > 0 && (
          <ColumnContainer columns={['13.5rem', '13.5rem']}>
            {children.splice(0, 2)}
          </ColumnContainer>
        )}
      </RowContainer>
    );

    if (children.length === 0) {
      break;
    }

    render.push(
      <RowContainer key={children.length} small columns={['15.8333333333rem', '31.6666666667rem']}>
        {children.splice(0, 2)}
      </RowContainer>
    );

    if (children.length === 0) {
      break;
    }

    render.push(
      <RowContainer key={children.length} small columns={['15.8333333333rem', '15.8333333333rem', '15.8333333333rem']}>
        {children.splice(0, 3)}
      </RowContainer>
    );
  }

  return render;
}

function mobileRows(children){
  const render = [];

  while (children.length > 0) {
    render.push(
      <Fragment key={children.length}>
        <RowContainer small columns={['25rem']}>
          {children.splice(0, 1)}
        </RowContainer>
        {children.length > 0 && (
          <RowContainer small columns={['50%', '50%']}>
            {children.splice(0, 2)}
          </RowContainer>
        )}
      </Fragment>
    );
  }
  return render;
}

const ROW_HEIGHT_SMALL_REM_MOBILE = '12rem';
const ROW_HEIGHT_SMALL_REM_TABLET = '18.5rem';
const ROW_HEIGHT_LARGE_REM_TABLET = '27rem';

const RowContainer = styled.div`
  display: flex;

  > * {
    margin-right: .5rem;
    margin-bottom: .5rem;
  }

  > *:last-child {
    margin-right: 0;
  }

  &:last-child > * {
    margin-bottom: 0;
  }

  ${({ columns }) => columns.map((column, index) => css`
    > *:nth-child(${index + 1}) {
      width: 100%;
      height: ${({ small }) => (
        small
          ? themeResponsiveProperty(ROW_HEIGHT_SMALL_REM_MOBILE, ROW_HEIGHT_SMALL_REM_TABLET)
          : themeResponsiveProperty(ROW_HEIGHT_LARGE_REM_TABLET, ROW_HEIGHT_LARGE_REM_TABLET)
      )};
      max-width: ${column};
    }
  `)};
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin-bottom: .5rem;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  ${({ columns }) => columns.map((column, index) => css`
    > *:nth-child(${index + 1}) {
      //height: ${column};
    }
  `)};
`;
